const siteId = process.env.REACT_APP_BUILD_SITE;

export const OPTIONAL_TOTAL_AREA = Object.freeze({
  '24MX': [],
  VAMX: [],
  UBPE: ['29'],
  DVPE: ['29'],
  ZPAR: [],
  CAPA: [],
  PLEC: [],
  IWBR: ['2', '1', '1005'],
  CMBR: ['2', '1', '1005'],
  WIBR: ['2', '1', '1005']
});

export const NOT_APPLY_TOTAL_AREA = Object.freeze({
  '24MX': [],
  VAMX: [],
  UBPE: [],
  DVPE: [],
  ZPAR: [],
  CAPA: [],
  PLEC: [],
  IWBR: [],
  CMBR: [],
  WIBR: []
});

export const OPTIONAL_COVERED_AREA = Object.freeze({
  '24MX': ['15', '24', '40', '3', '14', '17', '20'],
  VAMX: ['15', '24', '40', '3', '14', '17', '20'],
  UBPE: ['29', '26', '3'],
  DVPE: ['29', '26', '3'],
  ZPAR: ['26', '32', '14'],
  CAPA: ['3', '6'],
  PLEC: ['3', '6', '32'],
  IWBR: ['1003', '1004'],
  CMBR: ['1003', '1004'],
  WIBR: ['1003', '1004']
});

export const NOT_APPLY_COVERED_AREA = Object.freeze({
  '24MX': ['40', '3'],
  VAMX: ['40', '3'],
  UBPE: ['26', '3'],
  DVPE: ['26', '3'],
  ZPAR: [],
  CAPA: [],
  PLEC: [],
  IWBR: [],
  CMBR: [],
  WIBR: []
});

export const OPTIONAL_ANTIQUITY = Object.freeze({
  '24MX': ['40', '3', '14', '20', '24'],
  VAMX: ['40', '3', '14', '20', '24'],
  UBPE: ['29', '26', '3'],
  DVPE: ['29', '26', '3'],
  ZPAR: ['26', '14'],
  CAPA: ['3'],
  PLEC: ['6', '3', '11'],
  IWBR: ['1003', '1004'],
  CMBR: ['1003', '1004'],
  WIBR: ['1003', '1004']
});

export const NOT_APPLY_ANTIQUITY = Object.freeze({
  '24MX': ['40', '3', '14', '20', '24'],
  VAMX: ['40', '3', '14', '20', '24'],
  UBPE: ['26', '3'],
  DVPE: ['26', '3'],
  ZPAR: ['26', '14'],
  CAPA: ['3'],
  PLEC: ['3'],
  IWBR: ['1003', '1004'],
  CMBR: ['1003', '1004'],
  WIBR: ['1003', '1004']
});

export const OPTIONAL_ENVIRONMENTS = Object.freeze({
  '24MX': [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  VAMX: [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  UBPE: ['1', '2', '3', '4', '5', '22', '27', '28', '32', '38', '25', '26', '29'],
  DVPE: ['1', '2', '3', '4', '5', '22', '27', '28', '32', '38', '25', '26', '29'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '38', '2005', '26'],
  CAPA: ['1', '2', '3', '4', '5', '6', '7', '8', '10', '25', '38', '44'],
  PLEC: ['3', '32', '1', '2', '4', '5', '6', '7', '8', '9', '10', '11', '25'],
  IWBR: ['1005', '1004', '1003', '1', '2'],
  CMBR: ['1005', '1004', '1003', '1', '2'],
  WIBR: ['1005', '1004', '1003', '1', '2']
});

export const NOT_APPLY_ENVIRONMENTS = Object.freeze({
  '24MX': [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  VAMX: [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  UBPE: ['1', '2', '3', '4', '5', '22', '27', '28', '32', '38', '25', '26', '29'],
  DVPE: ['1', '2', '3', '4', '5', '22', '27', '28', '32', '38', '25', '26', '29'],
  ZPAR: ['2000', '14', '32', '26'],
  CAPA: ['1', '2', '3', '4', '5', '6', '7', '8', '10', '25', '38', '44'],
  PLEC: ['3', '32', '1', '2', '4', '5', '6', '7', '8', '9', '10', '11', '25'],
  IWBR: ['1005', '1004', '1003', '1', '2'],
  CMBR: ['1005', '1004', '1003', '1', '2'],
  WIBR: ['1005', '1004', '1003', '1', '2']
});

export const OPTIONAL_ROOMS = Object.freeze({
  '24MX': ['7', '17', '18', '5', '19', '22', '4', '40', '3', '20', '24', '21'],
  VAMX: ['7', '17', '18', '5', '19', '22', '4', '40', '3', '20', '24'],
  UBPE: ['29', '38', '3', '22', '5', '32', '26', '4'],
  DVPE: ['29', '38', '3', '22', '5', '32', '26', '4'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '38', '2005', '26', '2'],
  CAPA: ['3', '4', '5', '6', '7', '8', '10', '38'],
  PLEC: ['3', '32', '4', '5', '6', '7', '8', '10', '25'],
  IWBR: ['1005', '1004', '1003'],
  CMBR: ['1005', '1004', '1003'],
  WIBR: ['1005', '1004', '1003']
});

export const NOT_APPLY_ROOMS = Object.freeze({
  '24MX': ['7', '17', '18', '5', '19', '22', '4', '40', '20', '24', '3'],
  VAMX: ['7', '17', '18', '5', '19', '22', '4', '40', '20', '24', '3'],
  UBPE: ['3', '22', '5', '32', '26', '4'],
  DVPE: ['3', '22', '5', '32', '26', '4'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '2005', '26'],
  CAPA: ['3', '4', '5', '7', '8', '10', '38'],
  PLEC: ['3', '25', '4', '5', '32', '8'],
  IWBR: ['1003'],
  CMBR: ['1003'],
  WIBR: ['1003']
});

export const OPTIONAL_BATHROOMS = Object.freeze({
  '24MX': ['7', '17', '18', '5', '19', '22', '4', '40', '3', '20', '24', '15', '21'],
  VAMX: ['7', '17', '18', '5', '19', '22', '4', '40', '3', '20', '24', '15'],
  UBPE: ['29', '22', '5', '4', '32', '26', '3', '38'],
  DVPE: ['29', '22', '5', '4', '32', '26', '3', '38'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '38', '2005', '26'],
  CAPA: ['3', '4', '5', '6', '7', '8', '10', '38'],
  PLEC: ['3', '32', '4', '5', '6', '7', '8', '10', '25'],
  IWBR: ['1005', '1004', '1003'],
  CMBR: ['1005', '1004', '1003'],
  WIBR: ['1005', '1004', '1003']
});

export const NOT_APPLY_BATHROOMS = Object.freeze({
  '24MX': ['40', '20', '24', '3'],
  VAMX: ['40', '20', '24', '3'],
  UBPE: ['32', '26', '3'],
  DVPE: ['32', '26', '3'],
  ZPAR: ['2000', '14', '32', '26'],
  CAPA: [],
  PLEC: ['3'],
  IWBR: ['1003'],
  CMBR: ['1003'],
  WIBR: ['1003']
});

export const OPTIONAL_HALF_BATHROOMS = Object.freeze({
  '24MX': [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  VAMX: [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  UBPE: ['2', '4', '5', '22', '27', '28', '38', '25', '29', '32', '26', '3', '1'],
  DVPE: ['2', '4', '5', '22', '27', '28', '38', '25', '29', '32', '26', '3', '1'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '38', '2005', '26', '2001', '1', '2', '11'],
  CAPA: ['1', '2', '3', '4', '5', '6', '7', '8', '10', '25', '38', '44'],
  PLEC: ['3', '32', '1', '2', '4', '5', '6', '7', '8', '9', '10', '11', '25'],
  IWBR: ['1005', '1004', '1003', '1', '2'],
  CMBR: ['1005', '1004', '1003', '1', '2'],
  WIBR: ['1005', '1004', '1003', '1', '2']
});

export const NOT_APPLY_HALF_BATHROOMS = Object.freeze({
  '24MX': ['20', '24', '40', '3'],
  VAMX: ['20', '24', '40', '3'],
  UBPE: ['32', '26', '3', '1'],
  DVPE: ['32', '26', '3', '1'],
  ZPAR: ['32', '26'],
  CAPA: ['3'],
  PLEC: ['3'],
  IWBR: ['1003'],
  CMBR: ['1003'],
  WIBR: ['1003']
});

export const OPTIONAL_PARKING = Object.freeze({
  '24MX': [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  VAMX: [
    '1',
    '2',
    '4',
    '5',
    '7',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '24',
    '40',
    '3',
    '101'
  ],
  UBPE: ['2', '4', '5', '22', '27', '28', '38', '25', '29', '32', '26', '3', '1'],
  DVPE: ['2', '4', '5', '22', '27', '28', '38', '25', '29', '32', '26', '3', '1'],
  ZPAR: ['2000', '14', '4', '5', '7', '8', '10', '32', '45', '99', '38', '2005', '26', '2001', '1', '2', '11'],
  CAPA: ['1', '2', '3', '4', '5', '6', '7', '8', '10', '25', '38', '44'],
  PLEC: ['3', '32', '1', '2', '4', '5', '6', '7', '8', '9', '10', '11', '25'],
  IWBR: ['1005', '1004', '1003', '1', '2'],
  CMBR: ['1005', '1004', '1003', '1', '2'],
  WIBR: ['1005', '1004', '1003', '1', '2']
});

export const NOT_APPLY_PARKING = Object.freeze({
  '24MX': ['20', '24', '40', '3'],
  VAMX: ['20', '24', '40', '3'],
  UBPE: ['32', '26', '3', '1'],
  DVPE: ['32', '26', '3', '1'],
  ZPAR: ['14', '26'],
  CAPA: ['3'],
  PLEC: ['3'],
  IWBR: ['1003'],
  CMBR: ['1003'],
  WIBR: ['1003']
});

export const getIsOptionalCoveredArea = realEstateTypeId => {
  return OPTIONAL_COVERED_AREA[siteId].includes(realEstateTypeId);
};

export const getIsOptionalTotalArea = realEstateTypeId => {
  return OPTIONAL_TOTAL_AREA[siteId].includes(realEstateTypeId);
};

export const getIsOptionalAntiquity = realEstateTypeId => {
  return OPTIONAL_ANTIQUITY[siteId].includes(realEstateTypeId);
};

export const getAntiquityNotApply = realEstateTypeId => {
  if (!realEstateTypeId) return false;
  return NOT_APPLY_ANTIQUITY[siteId].includes(realEstateTypeId);
};

export const getCoveredAreaNotApply = realEstateTypeId => {
  if (!realEstateTypeId) return false;
  return NOT_APPLY_COVERED_AREA[siteId].includes(realEstateTypeId);
};

export const getConfigByRealEstateType = realEstateTypeId => {
  return {
    CFT101: {
      isOptional: OPTIONAL_COVERED_AREA[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_COVERED_AREA[siteId].includes(realEstateTypeId)
    },
    CFT2: {
      isOptional: OPTIONAL_ROOMS[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_ROOMS[siteId].includes(realEstateTypeId)
    },
    CFT3: {
      isOptional: OPTIONAL_BATHROOMS[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_BATHROOMS[siteId].includes(realEstateTypeId)
    },
    CFT4: {
      isOptional: OPTIONAL_HALF_BATHROOMS[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_HALF_BATHROOMS[siteId].includes(realEstateTypeId)
    },
    CFT7: {
      isOptional: OPTIONAL_PARKING[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_PARKING[siteId].includes(realEstateTypeId)
    },
    CFT5: {
      isOptional: OPTIONAL_ANTIQUITY[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_ANTIQUITY[siteId].includes(realEstateTypeId)
    },
    CFT1: {
      isOptional: OPTIONAL_ENVIRONMENTS[siteId].includes(realEstateTypeId),
      apply: !NOT_APPLY_ENVIRONMENTS[siteId].includes(realEstateTypeId)
    }
  };
};

export const mainFeaturesIds = {
  ANTIGUEDAD: 'CFT5',
  MEDIOS_BANOS: 'CFT4',
  BANOS: 'CFT3',
  HABITACIONES: 'CFT2',
  GARAGE: 'CFT7',
  SUP_TOTAL: 'CFT100',
  SUP_CUBIERTA: 'CFT101',
  AMBIENTES: 'CFT1'
};

export const featuresWithAllowedZeroValue = ['CFT2', 'CFT3', 'CFT4', 'CFT7'];

export const roomsOptionsConfig = [
  { label: 'professionalPubli.features.rooms.op5', featureId: 'CFT1', name: 'environment', initialValue: 0 },
  { label: 'professionalPubli.features.rooms.op1', featureId: 'CFT2', name: 'rooms', initialValue: 0 },
  { label: 'professionalPubli.features.rooms.op2', featureId: 'CFT3', name: 'bathroom', initialValue: 0 },
  { label: 'professionalPubli.features.rooms.op3', featureId: 'CFT4', name: 'half_bathroom', initialValue: 0 },
  { label: 'professionalPubli.features.rooms.op4', featureId: 'CFT7', name: 'parking', initialValue: 0 }
];
